import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { ReportActions } from '../../../actions/report';
import { currentProjectIdSelector } from '../../../reducers/projects';
import {
  shouldLoadReportSelector,
  dailyTaskCompleteReportsSelector,
} from '../../../reducers/reports';
import {
  currentUserSelector,
  userModeSelector,
  getUserModeByProjectId,
} from '../../../reducers/users';

import DailyTasksCompleteList from './DailyTasksCompleteList';

const DailyTasksCompleteListContainerSelector = immutableCreatorSelector(
  [
    currentProjectIdSelector,
    dailyTaskCompleteReportsSelector,
    shouldLoadReportSelector,
    currentUserSelector,
    userModeSelector,
  ],
  (currentProjectId, reports, shouldLoadReports, user, oldUserMode) => {
    return {
      currentProjectId,
      reports,
      shouldLoadReports,
      user,
      userMode: getUserModeByProjectId(user, currentProjectId),
    };
  },
);

@connect(DailyTasksCompleteListContainerSelector)
export default class DailyTasksCompleteListContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    currentProjectId: PropTypes.string,
    reports: PropTypes.instanceOf(Map),
    shouldLoadReports: PropTypes.bool,
  };

  componentDidMount = () => {
    const { dispatch, currentProjectId, shouldLoadReports } = this.props;

    if (shouldLoadReports) {
      dispatch(ReportActions.getReports(currentProjectId));
    }
  };

  render() {
    return <DailyTasksCompleteList {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/DailyTasksCompleteList/DailyTasksCompleteListContainer.js